import React, { Component } from "react";
import logo from "../../../assets/Mantelzorg.png";
import PhoneInput from "react-phone-number-input";
import Api from "../../../Api";
import { Link } from "react-router-dom";

class Opzeggingen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      loading: false,
      activitis: [],
    };

    this.TextField = this.TextField.bind(this);
    this.EmailField = this.EmailField.bind(this);
    this.PhoneField = this.PhoneField.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  async onSubmit(data) {
    this.setState({ loading: true });
    const today = new Date();

    const mantelzorg = {
      86146: today.toISOString(),
      86147: [parseInt(data.activiteit)],
      86154: [],
      86156: [43407],
      95630: data.voornaam,
      95631: data.achternaam,
      95632: data.postcode,
      95633: data.huisnummer,
      95634: data.email_melder,
      95635: data.phone_melder,
      98244: data.toelichting,
      defDossier: "4207",
    };

    await Api.dossiers.Create(mantelzorg, "API_ZVHC_USERNAME", "API_ZVHC_KEY");

    this.setState({ loading: false });
    this.setState({ showModal: true });
  }

  TextField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            htmlFor="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <input
            {...register(name, rules)}
            type="text"
            className="h-10 mt-1 border rounded px-2 w-full bg-gray-50"
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name] && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  EmailField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            htmlFor="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {(rules.required?.value ?? rules.required) && (
              <span className="text-red-500">*</span>
            )}{" "}
            {label}
          </label>
          <input
            {...register(name, rules)}
            type="email"
            className="h-10 mt-1 border rounded px-2 w-full bg-gray-50"
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  PhoneField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            htmlFor="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <PhoneInput
            placeholder="Vul een telefoonnummer"
            {...register(name, rules)}
            value={this.state[name]}
            onChange={(value) => this.setState({ [name]: value })}
            className="h-10 mt-1 border rounded px-2 w-full bg-gray-50"
          />

          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  TextAreaField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start w-full">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <textarea
            rows={7}
            {...register(name, rules)}
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
            className="block p-2 w-full text-sm text-gray-900  rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
          ></textarea>

          {errors[name] && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  DateField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    const today = new Date().toISOString().split("T")[0];

    return (
      <>
        <div className="flex flex-col items-start">
          <label htmlFor={name} className="form-label fw-bold float-start">
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>

          <input
            {...register(name, rules)}
            type="date"
            defaultValue={today}
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  SelectField(label, name, options, rules, defaultValue = "") {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label for={name} className="form-label fw-bold float-start">
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>

          <select
            {...register(name, rules)}
            name={name}
            value={this.state[name] || defaultValue}
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
          >
            <option value="">Selecteer een optie</option>
            {options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  formatDateToISO(date) {
    const isoString = new Date(date).toISOString();
    return isoString;
  }

  async componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const someValue = queryParams.get("dossierQuery");

    if (someValue) {
      const actMantel = await Api.dossiers.GetDefdossier({
        defDossier: 3659,
        environment: 299,
        limit: 25,
        dossierQuery: someValue,
      });

      const filteredActivities = actMantel.results.dossiers
        .filter((act) => act.archived === false)
        .map((act) => ({
          value: act.id,
          label: act.summary,
        }));

      this.setState({ activitis: filteredActivities });
    } else {
      const activiti = await Api.dossiers.GetDefdossier({
        defDossier: "3659",
        limit: 50,
        page: 0,
      });

      const filteredActivities = activiti.results.dossiers
        .filter((act) => act.archived === false)
        .map((act) => ({
          value: act.id,
          label: act.summary,
        }));

      this.setState({ activitis: filteredActivities });
    }
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <>
        {this.state.loading && (
          <div className="flex items-center justify-center h-screen fixed w-full z-50">
            <div className="bg-slate-500 absolute w-full h-full  opacity-50"></div>
            <div class="relative">
              <div className="h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-200"></div>
              <div className="absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-300 animate-spin"></div>
            </div>
          </div>
        )}
        {this.state.showModal && (
          <div
            id="successModal"
            tabindex="-1"
            aria-hidden="true"
            class="flex overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full"
          >
            <div className="bg-slate-500 absolute w-full h-full opacity-50"></div>
            <div class="relative p-4 w-full max-w-lg h-full md:h-auto">
              <div class="relative p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
                <button
                  onClick={() => {
                    this.setState({ showModal: false });
                  }}
                  type="button"
                  class="text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-toggle="successModal"
                >
                  <svg
                    aria-hidden="true"
                    class="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="sr-only">Close modal</span>
                </button>
                <div class="w-12 h-12 rounded-full bg-green-100 dark:bg-green-900 p-2 flex items-center justify-center mx-auto mb-3.5">
                  <svg
                    aria-hidden="true"
                    class="w-8 h-8 text-green-500 dark:text-green-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="sr-only">Success</span>
                </div>
                <p class="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
                  Je bent nu ingeschreven voor de activiteit. Voor een andere
                  activiteit inschrijven? Klik op ga door.
                </p>
                <button
                  onClick={() => {
                    this.setState({ showModal: false });
                  }}
                  type="button"
                  class="py-2 px-3 text-sm font-medium text-center text-white rounded-lg bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 "
                >
                  Ga door
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="flex flex-col justify-start px-20">
          <p className="text-start text-2xl spt-2 mt-2 font-bold text-yellow-400">
            Schrijf je in voor een activiteit
          </p>
          <div className="flex flex-row justify-between items-center border-2 border-yellow-400 py-2 px-4 mt-2">
            <p>
              Schrijf je hieronder in voor een activiteit van Steunpunt
              Mantelzorg Verlicht. Ben je als mantelzorger nog niet ingeschreven
              bij ons steunpunt? Schrijf je dan eerst
              <Link
                className="text-blue-500 underline ml-1"
                to="https://next-forms.kedo.nu/form/inschrijven-als-mantelzorger?18843=3168706"
              >
                hier in.
              </Link>
            </p>
            <img
              src={logo}
              alt="star"
              style={{ width: 130, height: 80, marginRight: 4 }}
            />
          </div>
        </div>

        <div className="py-3 px-20 d-flex flex-column gap-5">
          <div className=" bg-white rounded-lg shadow-md border border-gray-200 py-6 px-10">
            <p className="text-start text-xl spt-2 mt-2 font-bold">
              Inschrijven voor activiteit
            </p>
            <div className="mt-6" onSubmit={this.submitForm}>
              <form className="grid grid-cols-3 gap-4 mt-3">
                {this.SelectField(
                  "Activiteit",
                  "activiteit",
                  this.state.activitis,
                  {
                    required: true,
                  }
                )}
                {this.SelectField(
                  "Inschrijven",
                  "inschrijven",
                  [
                    {
                      value: 43407,
                      label: "Inschrijven",
                    },
                  ],
                  {
                    required: false,
                  },
                  "43407"
                )}
                {this.DateField("Datum inschrijving", "datum_melding", {
                  required: "This Field required",
                })}
                {this.TextField("Voornaam", "voornaam", {
                  required: true,
                })}
                {this.TextField("Achternaam", "achternaam", {
                  required: true,
                })}
                {this.TextField("Postcode", "postcode", {
                  required: true,
                })}
                {this.TextField("Huisnummer", "huisnummer", {
                  required: true,
                })}
                {this.EmailField("E-mailadres", "email_melder", {
                  required: { value: true, message: "Email is required" },
                })}
                {this.PhoneField("Telefoonnummer(s)", "phone_melder", {
                  required: "Phone number is required",
                })}
              </form>
            </div>

            <div className="mt-6" onSubmit={this.submitForm}>
              {this.TextAreaField("Toelichting", "toelichting", {})}
            </div>

            <div className="mt-4" onSubmit={handleSubmit(this.onSubmit)}>
              <form>
                <button
                  type="submit"
                  className="bg-yellow-500 text-white font-bold px-6 py-2 rounded-3xl flex justify-center items-center hover:border hover:border-yellow-500 transition duration-300 ease-in-out"
                >
                  VERSTUUR
                </button>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Opzeggingen;
